export default __webpack_public_path__ + "static/media/Nunito-Light.f819f654.eot";